import { Component, OnInit, ViewChild } from '@angular/core';
import { Announcement, IAnnouncement } from '../../../types/website-builder/announcement';
import { NgForm } from '@angular/forms';
import { AnnouncementApiService } from '../../../services/api/announcement-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BuildingApiService } from '../../../services/api/building-api.service';
import { AnnouncementViewComponent } from '../announcement-view/announcement-view.component';
import { FileDocument } from '../../../types/file-document';
import { IToastr } from '../../../types/toastr';
import * as _ from 'lodash';
import { UnsavedDataCheck } from '../../../types/unsaved-data-check';
import { IWebsiteBuilder } from '../../../types/api-response/auth/website-builder';

declare const toastr: IToastr;

@Component({
    selector: 'announcements-add',
    templateUrl: './announcements-add.component.html',
    styleUrls: ['./announcements-add.component.scss']
})
export class AnnouncementsAddComponent implements OnInit, UnsavedDataCheck {

    @ViewChild('form') form: NgForm;

    isSpinnerShow;

    disabledSubmit;

    noticeStore: IAnnouncement;

    notice: IAnnouncement = new Announcement();

    isEndDateEnabled = false;

    corporationNumberOptions = [];

    today: Date = new Date();

    isFile = false;

    supportedFileTypes: string[] = AnnouncementViewComponent.supportedFileTypes;

    constructor(
        private announcementApi: AnnouncementApiService,
        private buildingApi: BuildingApiService,
        private router: Router,
        private route: ActivatedRoute,
    ) {
    }

    ngOnInit() {
        this.setCorporationNumberOptions();
        this.notice = this.getInitialNotice();
        this.setNoticeStore();

        // Enabled if end date set
        this.isEndDateEnabled = !!this.notice.periodEnd;

        // File mode if file link set
        this.isFile = !!this.notice.document;
    }

    getInitialNotice(): IAnnouncement {
        const notice = this.route.snapshot.data.notice;

        // Update value if single option
        if (this.corporationNumberOptions.length === 1 && !notice.corporationNumberId) {
            notice.corporationNumberId = this.corporationNumberOptions[0].value;
            notice.corporationNumberName = this.corporationNumberOptions[0].optionText;
        }

        return notice;
    }

    private setCorporationNumberOptions() {
        if(this.route.snapshot.data.websites) {
            this.corporationNumberOptions = (this.route.snapshot.data.websites as IWebsiteBuilder[]).map(website => ({
                value: +website.corporationNumberId,
                optionText: website.corporationNumber
            }));
        }
    }

    /**
     * Checks for not saved data
     */
    hasUnsavedData(): boolean {
        return  !_.isEqual(this.notice, this.noticeStore);
    }

    private setNoticeStore() {
        this.noticeStore = _.clone(this.notice);
    }

    /**
     * Updates notice corporation number name
     */
    corporationChange(corporationNumberId: number) {
        const corporation = this.corporationNumberOptions.find(corp => +corp.value === +corporationNumberId);
        this.notice.corporationNumberName = corporation.optionText;
    }

    periodBeginChange() {
        if (this.notice.periodEnd && this.notice.periodEnd < this.notice.periodBegin) {
            this.notice.periodEnd = null;
        }
    }

    periodEndChange() {
        // shift the time of selected date to the last second of day
        (this.notice.periodEnd as Date).setSeconds(24 * 60 * 60 - 1);
    }

    /**
     * Process form submission
     */
    onSubmit(form: NgForm) {
        if (form.valid) {
            this.disabledSubmit = true;
            this.announcementApi.setNotice(this.notice).subscribe(response => {
                this.setNoticeStore();
                this.router.navigateByUrl('/announcements');
            }, () => {
                this.disabledSubmit = false;
                toastr.error('Failed to publish announcement', 'Error');
            });
        }
    }

    onFileUploaded(document: FileDocument) {
        this.notice.document = document;
    }

    get announcementViewHeight() {
        return `calc(100vh - ${this.corporationNumberOptions.length > 1 ? 49 : 44}rem)`;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/announcements/announcements-add/announcements-add.component.ts